import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';

export interface LoaderProps {
    className?: string;
    isLoading: boolean;
    children?: React.ReactNode;
}

export const Loader = (props: LoaderProps) => {
    return (
        <>
            {props.isLoading && (
                <div className={classNames('Loader', props.className && props.className)}>
                    <div className="Loader__Inner">
                        <div className="Loader__Spinner">
                            <span className="visuallyHidden">{getTranslation(keys['productFilters.loading'])}</span>
                        </div>
                    </div>
                </div>
            )}
            {props.children}
        </>
    );
};
